// Import components.
import UgcWall from './components/UgcWall.jsx';

/**
 * <pre>
 * UgcWall module React Components.
 *
 * Summary of responsibilities:
 *
 *  - defines React components that this app module can render
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:UgcWall
 * @namespace
 *
 * @type {Object}
 */
const Components = {
	UgcWall: UgcWall
};

export default Components;